<template>
    <div>
        <div v-show="current_view == 'seller'">
            <compliance-seller
                :identification_number="identification"
                :selected_month="month"
                :selected_year="year"
                :current_view="current_view"
                @getView="handleView"
                :hidden_simulator="hidden_simulator"
                :hidden_title="hidden_title"
                :hidden_rent="hidden_rent"
                :segment_display_rv="segment_display_rv"
                :accelerators="accelerators"
                :payments_rv="payments_rv"
            ></compliance-seller>
        </div>
        <div v-show="current_view == 'simulator'">
            <compliance-simulator
                :data_rv="data_current_rv"
                @getView="handleView"
                :segment_display_rv="segment_display_rv"
                :accelerators="accelerators"
                :payments_rv="payments_rv"
            ></compliance-simulator>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        identification: {
            default: null,
        },
        month: {
            default: null,
        },
        year: {
            default: null,
        },
        hidden_simulator: {
            default: false
        },
        hidden_title: {
            default: false,
        },
        hidden_rent: {
            default: false,
        },
        segment_display_rv: {
            default: null,
        },
        accelerators: {
            default: null,
        },
        payments_rv: {
            default: null,
        },
    },
    data() {
        return {
            available_client_current_months: [],
            data_rv_ref: [],
            data_current_rv: [],
            selected_month: null,
            selected_year: null,
            current_month:null,
            current_year:null,
            current_view: 'seller',
        }
    },
    mounted () {

        this.current_month = this.getCurrentMonth()
        this.current_year = this.getCurrentYear()

        if(this.available_client_current_months.length == 0){
            this.getCurrentData()
        }
    },
    methods: {
        getCurrentData() {
            axios.get(`/get-home-from-api-result?identification=${this.identification}&month=${this.current_month}&year=${this.current_year}`)
                 .then(({data}) => {
                    this.data_current_rv = data.data_rv
                    this.loading--
                })
        },
        handleMonth(value) {
            this.selected_month = value
            this.getData()
        },
        handleView(value) {
            this.current_view = value
        },
        getCurrentMonth() {
            const today = new Date();
            const currentMonth = today.getMonth() + 1;
            return currentMonth;
        },
        getCurrentYear() {
            const today = new Date();
            const currentYear = today.getFullYear();
            return currentYear;
        },
    },
}
</script>
